import { Box, Container, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import StorageIcon from "@mui/icons-material/Storage";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import ShareIcon from "@mui/icons-material/Share";
import Source from "../../Components/Source";
import variables from "../../../assets/styles/variables.module.scss";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BasicDetails from "../../Components/BasicDetails";
// import AiSettings from "../../Components/AiSettings";
import Playground from "../../Components/PlaygroundOld";
import { Params, useParams } from "react-router-dom";
// import TabPanel, { a11yProps } from "../../../Shared-ui/SharedComponents/TabPanel";
import MetaInstance, { MetaMultipartInstance } from "../../../Services/AxiosInstance/MetaInstance";
import { GET_AGENT } from "../../../Services/Endpoint";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { useDispatch } from "react-redux";
import IAgent from "../../../Shared-ui/Types/OldAgent";
// import Connect from "../../Components/Connect";
import { Height } from "@mui/icons-material";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{flex:1}}
    >
      {value === index && <Box sx={{ py: 3, height: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OldAgent = () => {
  // url params
  const { agentId } = useParams<Params>();

  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"));
  const [value, setValue] = React.useState(1);
  const [knowledgeBase, setknowledgeBase] = useState<IAgent>()


  useEffect(() => {
    getknowledgeBase()
    if(knowledgeBase?.gptModel){
      setValue(2)
    }
  }, [agentId, knowledgeBase?.gptModel])



  const getknowledgeBase = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(res => res?.data?.detail)
      setknowledgeBase(data.response)
      if(!data?.response?.gptModel){
        setValue(1)
      }
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }

  const updateknowledgeBase = async () => {
    try {
      dispatch(StartLoading())
      const payload = knowledgeBase
      if (knowledgeBase?.icon && knowledgeBase?.icon instanceof File) {
        const form = new FormData()
        form.append('file', knowledgeBase.icon)
        const iconData = await MetaMultipartInstance.post(`${GET_AGENT}/${agentId}/icon`, form).then(res => res?.data?.detail)
        delete payload?.icon
      }
      const data = await MetaInstance.put(`${GET_AGENT}/${agentId}`, payload).then(res => res?.data?.detail)
      getknowledgeBase()
      dispatch(ShowSuccess(data?.response))
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };



  return (
    <Container maxWidth="xl" sx={{ py: 3, height: "calc(100vh - 78px)" }}>
      
      <Box sx={{ 
        width: "100%", 
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            position: { xs: "fixed", sm: "static" },
            bottom: { xs: "0px", sm: "unset" },
            left: { xs: "0px", sm: "unset" },
            right: { xs: "0px", sm: "unset" },
            background: variables.whiteColor,
            boxShadow: { xs: "0px 4px 10px rgba(0, 0, 0, 0.2)", sm: "none" },
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Breadcrumb data={[{ name: knowledgeBase?.name ||" New AI Agent", path: "" }]} />
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{ minHeight: "68x", height: "68px", mt: "12px"}}
          >
            <Tab
              icon={<TextSnippetIcon />}
              iconPosition={isXsScreen ? "top" : "start"}
              label="Agent Details"
              {...a11yProps(0)}
              sx={{ minHeight: "32px", height: "32px"}}
            />
            <Tab
              icon={<AutoFixHighOutlinedIcon />}
              iconPosition={isXsScreen ? "top" : "start"}
              label="AI Settings"
              {...a11yProps(1)}
              sx={{ minHeight: "32px", height: "32px"}}
            />
            <Tab
              icon={<StorageIcon />}
              iconPosition={isXsScreen ? "top" : "start"}
              label="SOURCES"
              {...a11yProps(2)}
              sx={{ minHeight: "32px", height: "32px"}}
            />
            
            <Tab
              icon={<GolfCourseIcon />}
              iconPosition={isXsScreen ? "top" : "start"}
              label="Playground"
              {...a11yProps(3)}
              sx={{ minHeight: "32px", height: "32px"}}
            />
            <Tab
              icon={<ShareIcon />}
              iconPosition={isXsScreen ? "top" : "start"}
              label="CONNECT"
              {...a11yProps(4)}
              sx={{ minHeight: "32px", height: "32px"}}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <BasicDetails
            />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {/* <AiSettings /> */}
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Source />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Playground />
        </TabPanel>
        <TabPanel value={value} index={4}>
          {/* <Connect/> */}
        </TabPanel>
      </Box>
    </Container>
  );
};

export default OldAgent;
